
<template>
  <div>
    
    <v-dialog v-model="dialog" scrollable persistent max-width="1200px" transition="dialog-transition" >
      <template v-slot:activator='{on}'>
        <v-btn v-on="on" small color="white black--text"><v-icon left>mdi-email-plus-outline</v-icon> Gerar envelope </v-btn>
      </template>
      <v-card class="charge-dialog-card" v-if="dialog">
        <div class="charge-dialog-header charge-dialog-header--envelope">
          <div class="d-flex align-center">
            <v-avatar color="white" size="40" class="mr-3 elevation-1">
              <v-icon color="blue-grey darken-2">mdi-email-outline</v-icon>
            </v-avatar>
            <div>
              <div class="headline white--text mb-0">Gerar Envelope</div>
              <div class="caption white--text" style="opacity:.85">Escolha os recebimentos em dinheiro e cheque que vão no envelope</div>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </div>
        </div>
        <v-card-text class="pa-5">
          <v-row dense align="center" class="mb-3">
            <v-col cols="12" sm="8">
              <SelectModality :object_with_model="new_envelope" custom_label="Módulo" outlined dense preselect_active/>
            </v-col>
            <v-col cols="12" sm="4">
              <v-btn block depressed color="blue-grey darken-2" class="white--text" :disabled="!new_envelope.place_id" @click="getPayments()">
                <v-icon left small>mdi-filter-outline</v-icon>Buscar pagamentos
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="loading_payments ? [] : all_payments"
            class="elevation-0"
            ref='table'
            show-select
            :loading='loading_payments'
            v-model="selected"
            mobile-breakpoint="1"
          >

            <template v-slot:item.attributes.payed_at="{item}">
              <span>
                {{$moment(item.attributes?.payed_at?.substring(0,10)).format('L')}}
              </span>
            </template>
            <template v-slot:item.attributes.total_value="{item}">
              {{Number(item.attributes?.total_value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
            </template>
            <template v-slot:item.attributes.cash_value="{item}">
              {{Number(item.attributes?.cash_value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
            </template>
            <template v-slot:item.attributes.check_value="{item}">
              {{Number(item.attributes?.check_value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
            </template>
            <template v-slot:item.attributes.action="{item}">
              <v-btn icon color="error" @click="deletePayment(item.attributes?.id)" :disabled="item.attributes?.client_name?.toLowerCase()?.includes(' final ')"><v-icon>mdi-delete</v-icon></v-btn>
            </template>
            
          </v-data-table>

          <v-row dense class="my-3">
            <v-col cols="12" sm="4">
              <div class="charge-summary-card d-flex align-center">
                <v-avatar size="40" color="green lighten-5" class="mr-3">
                  <v-icon color="green darken-2">mdi-currency-brl</v-icon>
                </v-avatar>
                <div>
                  <div class="caption grey--text text--darken-1">Valor selecionado</div>
                  <div class="subtitle-1 font-weight-bold">{{ formatMoney(total_value_select_payments) }}</div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <div class="charge-summary-card d-flex align-center">
                <v-avatar size="40" color="blue-grey lighten-5" class="mr-3">
                  <v-icon color="blue-grey darken-2">mdi-receipt</v-icon>
                </v-avatar>
                <div>
                  <div class="caption grey--text text--darken-1">Pagamentos selecionados</div>
                  <div class="subtitle-1 font-weight-bold">{{ total_select_payments }}</div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <div class="charge-summary-card d-flex align-center">
                <v-avatar size="40" color="orange lighten-5" class="mr-3">
                  <v-icon color="deep-orange darken-2">mdi-cash-multiple</v-icon>
                </v-avatar>
                <div>
                  <div class="caption grey--text text--darken-1">Dinheiro / Cheques</div>
                  <div class="body-2 font-weight-bold">{{ formatMoney(total_cash_select_payments) }} / {{ formatMoney(total_check_select_payments) }}</div>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-form ref="envelopeComment" lazy-validation>
            <v-textarea v-model="new_envelope.comment" rows="2" auto-grow prepend-inner-icon="mdi-comment-outline" label="Comentários" outlined dense hide-details="auto"></v-textarea>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="dialog=false">Cancelar</v-btn>
          <v-btn color="blue-grey darken-2" depressed class="px-5 white--text" :disabled="total_select_payments < 1" @click="swallConfirmSubmit">
            <v-icon left small>mdi-email-check-outline</v-icon>
            Gerar envelope
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_after_create" persistent max-width="500px" transition="dialog-transition">
      <v-card class="charge-dialog-card">
        <div class="charge-dialog-header charge-dialog-header--envelope py-4">
          <div class="d-flex align-center">
            <v-icon color="white" class="mr-3">mdi-email-check-outline</v-icon>
            <div class="title white--text">Envelope {{ created_envelope.name }} gerado</div>
          </div>
        </div>
        <v-card-text class="title pt-5">
          <v-row class="pa-0">
            <v-col cols="6" class="pa-0 pb-1">
              <span>Valor Total: </span>
            </v-col>
            <v-col cols="6" class="pa-0 pb-1 text-end">
              <b>{{ Number(created_envelope?.total_value || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</b>
            </v-col>
          </v-row>
          <v-row class="pa-0">
            <v-col cols="6" class="pa-0 pb-1">
              <span>Dinheiro: </span>
            </v-col>
            <v-col cols="6" class="pa-0 pb-1 text-end">
              <b class="font-weight-light"> {{ Number(created_envelope?.total_in_cash || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</b>
            </v-col>
          </v-row>
          <v-row class="pa-0">
            <v-col cols="6" class="pa-0 pb-1">
              <span>Cheques: </span>
            </v-col>
            <v-col cols="6" class="pa-0 pb-1 text-end">
              <b class="font-weight-light"> {{ Number(created_envelope?.total_in_checks || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</b>
            </v-col>
          </v-row>
          <FileAttachment class="mt-3" :update_infos="{MODEL: 'Envelope', id: parseInt(created_envelope.id)}">
          </FileAttachment>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn @click="dialog_after_create = !dialog_after_create" color="blue-grey darken-2" depressed class="px-5 white--text">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading v-if="loading"></dialog-loading>
  </div>
</template>

<script>
import Api from '@/api/index';
import validations from '@/mixins/validations'
import status from "@/_backoffice/_financial/mixins/status.js"

export default {
  name: "NewEnvelopeDialog",
  mixins: [ validations, status ],
  components: {
    SelectModality: () => import('@/components/shared/SelectModality.vue'),
    FileAttachment: () => import('@/components/shared/FileAttachment.vue'),
  },
  data() {
    return {
      dialog_after_create: false,
      dialog: false,
      loading: false,
      selected: [],
      all_payments: [],
      loading_payments: false,
      new_envelope: {
        comment: null,
        place_id: null
      },
      created_envelope: {
        name: '',
        total_in_cash: '0',
        total_in_checks: '0',
        total_value: '0',
      },
      headers: [
        { text: 'Cliente', value: 'attributes.client_name', width: '30%' },
        { text: 'Valor total', value: 'attributes.total_value', width: '15%' },
        { text: 'Em dinheiro', value: 'attributes.cash_value', width: '20%' },
        { text: 'Em cheque', value: 'attributes.check_value', width: '20%' },
        { text: 'Pago em', value: 'attributes.payed_at', width: '15%' },
        { text: 'Apagar', value: 'attributes.action', width: '5%' },
      ],
    }
  },
  methods: {
    formatMoney(value) {
      return Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    deletePayment(id){
      this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        title: `Deseja EXCLUIR este pagamento?`,
        icon: 'warning',
      }).then(r=>{
        if (r.isConfirmed) {
          this.loading = true
          Api.Payment.delete(id).then(respose=>respose.data).then(()=>{
            this.getPayments()
            this.loading = false
          })
        }
      })
    },
    getPayments(){
      this.selected = []
      this.new_envelope.comment = null
      this.loading_payments = true
      let filters = {
        modality_ids: [this.new_envelope.place_id],
        status_ids: [this.status_id_map['Payed']],
        kinds: [0]
      }
      Api.Payment.index(filters).then(r=>r.data).then(r=>{
        this.all_payments = [...r.data]
      }).finally(()=>{
        this.loading_payments = false
      })
    },
    swallConfirmSubmit(){
      if (this.selected.length) {
        this.$swal({
          showConfirmButton: true,
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          title: `Gerar envelope?`,
          icon: 'question',
        }).then(r=>{
          if (r.isConfirmed) {
            this.loading = true

            let env = this.genEnvelope()
            this.createEnvelope(env)
            this.all_payments = []
          }
        })
      }
    },
    setCreatedEnvelope(response){
      this.created_envelope = {...response}
      this.dialog_after_create = true
    },
    createEnvelope(env){
      Api.Envelope.create(env).then(r => r.data).then(r=>{
        this.setCreatedEnvelope(r)
        this.successSaved()
        this.$emit('doneNewEnvelope', r)
        this.dialog = false
      }).catch(err=> {
        console.log({err});
        this.errorCreated()
      }).finally(()=>{
        this.loading = false
      })
    },
    genEnvelope(){
      let env = {
        // name: "ENV-2129-149",
        // code: "ENV-2129-149",
        comment: this.new_envelope.comment,
        payment_ids: this.selected.map(s=> Number(s.id)), // ! DEVE existir no proto

        all_confirmed: false,
        is_updating: false,
        place_id: this.new_envelope.place_id,
      }
      return env
    },
  },
  computed: {
    total_select_payments() {
      return this.selected.length 
    },
    total_value_select_payments() {
      let total = 0
      if (this.selected.length){
        total = this.selected.reduce((acc, one)=> acc + Number(one.attributes.total_value) ,0)
      }
      return total
    },
    total_cash_select_payments() {
      return this.selected.reduce((acc, one) => acc + (Number(one.attributes?.cash_value) || 0), 0)
    },
    total_check_select_payments() {
      return this.selected.reduce((acc, one) => acc + (Number(one.attributes?.check_value) || 0), 0)
    },
  },
  watch: {
    dialog(nv,ov) {
      if (nv == false){
        this.selected = []
        this.new_envelope.comment = null
        this.created_envelope.comment = { 
          name: '',
          total_in_cash: '0',
          total_in_checks: '0',
          total_value: '0',
        }
      }
    },
  },
}
</script>

<style src="../../../styles/charge_dialog.css"></style>
